import { atom } from 'recoil'

export const isOpenInstallationState = atom({
  key: 'isOpenInstallationState',
  default: false
})
